export const seriesId = [
  "c0_producto_real_agrario",
  "c0_poblacion_urbana",
  "c0_producto_real_total",
  "c0_poblacion",
  "c0_producto_real_per_capita",
  "c0_pibpm_nominal",
  "c0_pibpm_nominal_per_capita",
  "c1_indice_de_williamson_nominal",
  "c1_ratio_renta_de_la_tierra_salario_nominal",
  "c2_espana",
  "c2_francia",
  "c2_reino_unido",
  "c2_paises_bajos",
  "c2_suecia"
]

export const seriesEsp = [
  "Producto Real Agrario",
  "Población Urbana",
  "Producto Real Total",
  "Población",
  "Producto Real per Capita",
  "PIBpm Nominal",
  "PIBpm Nominal Per Capita",
  "Índice de Williamson (Nominal)",
  "Ratio Renta de la tierra/Salario (Nominal)",
  "España",
  "Francia",
  "Reino Unido",
  "Países Bajos",
  "Suecia"
]

export const seriesEng = [
  "Real Agricultural Output",
  "Urban Population",
  "Real Total Output",
  "Population",
  "Real Output per Head",
  "Nominal GDPmp",
  "Per Capita GDPmp",
  "Nominal Williamson Index",
  "Nominal Land Rent/Wage",
  "Spain",
  "France",
  "United Kingdom",
  "Netherlands",
  "Sweden"
]

export const unitsEsp =[
  "(1850/9=100)",
  "(1850/9=100)",
  "(1850/9=100)",
  "millones",
  "(1850/9=100)",
  "millones (Reales)",
  "actuales (Reales)",
  "1790/99=100",
  "1790/99=100",
  "dólares Geary-Khamis de 1990",
  "dólares Geary-Khamis de 1990",
  "dólares Geary-Khamis de 1990",
  "dólares Geary-Khamis de 1990",
  "dólares Geary-Khamis de 1990",
]

export const unitsEng =[
  "(1850/9=100)",
  "(1850/9=100)",
  "(1850/9=100)",
  "millions",
  "(1850/9=100)",
  "millions (Reales)",
  "current (Reales)",
  "1790/99=100",
  "1790/99=100",
  "Geary-Khamis dollars 1990",
  "Geary-Khamis dollars 1990",
  "Geary-Khamis dollars 1990",
  "Geary-Khamis dollars 1990",
  "Geary-Khamis dollars 1990",
]

export const groupsEsp = [
  "PIB, población y PIB por habitante, 1277-1850",
  "PIB, población y PIB por habitante, 1277-1850",
  "PIB, población y PIB por habitante, 1277-1850",
  "PIB, población y PIB por habitante, 1277-1850",
  "PIB, población y PIB por habitante, 1277-1850",
  "PIB, población y PIB por habitante, 1277-1850",
  "PIB, población y PIB por habitante, 1277-1850",
  "Distribución de la renta: Índice de Williamson* y Ratio Renta de la tierra/salario, 1277-1850",
  "Distribución de la renta: Índice de Williamson* y Ratio Renta de la tierra/salario, 1277-1850",
  "Producto Interior Bruto Real per capita en perspectiva europea, 1277-1850 (dólares Geary-Khamis de 1990; nivel de 1990, Maddison Project v. 2013)",
  "Producto Interior Bruto Real per capita en perspectiva europea, 1277-1850 (dólares Geary-Khamis de 1990; nivel de 1990, Maddison Project v. 2013)",
  "Producto Interior Bruto Real per capita en perspectiva europea, 1277-1850 (dólares Geary-Khamis de 1990; nivel de 1990, Maddison Project v. 2013)",
  "Producto Interior Bruto Real per capita en perspectiva europea, 1277-1850 (dólares Geary-Khamis de 1990; nivel de 1990, Maddison Project v. 2013)",
  "Producto Interior Bruto Real per capita en perspectiva europea, 1277-1850 (dólares Geary-Khamis de 1990; nivel de 1990, Maddison Project v. 2013)"
]

export const groupsEng = [
  "GDP, population and GDP per capita, 1277-1850",
  "GDP, population and GDP per capita, 1277-1850",
  "GDP, population and GDP per capita, 1277-1850",
  "GDP, population and GDP per capita, 1277-1850",
  "GDP, population and GDP per capita, 1277-1850",
  "GDP, population and GDP per capita, 1277-1850",
  "GDP, population and GDP per capita, 1277-1850",
  "Income distribution: Williamson* Index and Land Rent/Wage, 1277-1850",
  "Income distribution: Williamson* Index and Land Rent/Wage, 1277-1850",
  "Real GDP per capita in European perspective, 1277-1850 (Geary-Khamis dollars 1990; Maddison Project v. 2013)",
  "Real GDP per capita in European perspective, 1277-1850 (Geary-Khamis dollars 1990; Maddison Project v. 2013)",
  "Real GDP per capita in European perspective, 1277-1850 (Geary-Khamis dollars 1990; Maddison Project v. 2013)",
  "Real GDP per capita in European perspective, 1277-1850 (Geary-Khamis dollars 1990; Maddison Project v. 2013)",
  "Real GDP per capita in European perspective, 1277-1850 (Geary-Khamis dollars 1990; Maddison Project v. 2013)"
]
